export default "__VITE_ASSET__BeR5ivAO__"